import React from 'react';
import { FaUpload } from 'react-icons/fa';
import { HeaderButton } from '../styles';

const FileUploadButton = ({ 
  onFileProcess, 
  fileInputRef,
  disabled = false,
  standalone = true
}) => {
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    onFileProcess(file);
    event.target.value = '';
  };

  return (
    <>
      {standalone && (
        <input
          ref={fileInputRef}
          type="file"
          accept=".csv"
          onChange={handleFileUpload}
          style={{ display: 'none' }}
          disabled={disabled}
        />
      )}
      
      <HeaderButton
        onClick={(e) => {
          if (!standalone) e.stopPropagation();
          fileInputRef?.current?.click();
        }}
        disabled={disabled}
      >
        <FaUpload style={{ marginRight: '4px' }} />
        Browse Files
      </HeaderButton>
    </>
  );
};

export default FileUploadButton;